import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useCommonInfoStore = defineStore(
  'commonInfo',
  () => {
    const accessSource = ref('')
    const setAccessSourceValue = (value) => {
      accessSource.value = value
    }

    const commonHeaderHeight = ref(0)
    const setCommonHeaderHeightValue = (value) => {
      commonHeaderHeight.value = value
    }

    const windowWidth = ref(0)
    const windowHeight = ref(0)
    const setWindowSizeValue = (width, height) => {
      windowWidth.value = width
      windowHeight.value = height
    }

    return {
      accessSource,
      setAccessSourceValue,
      commonHeaderHeight,
      setCommonHeaderHeightValue,
      windowWidth,
      windowHeight,
      setWindowSizeValue
    }
  },
  {
    persist: [{
      paths: [
        'accessSource',
        'commonHeaderHeight',
        'windowWidth',
        'windowHeight'
      ],
      storage: sessionStorage
    }]
  }
)